import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["isOpen", "title", "message", "onClose", "onApply", "renderMessage", "hideCloseButton", "hideConfirmButton", "confirmButtonText", "cancelButtonText", "size", "ariaLabel"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { WarningIcon } from '@chakra-ui/icons';
import { HStack, Modal, ModalBody, ModalContent, ModalFooter, ModalOverlay, Text } from '@chakra-ui/react';
import { Button } from '@cofit/components';
import { useTranslation } from 'next-i18next';
import TitleHeader from './TitleHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ConfirmModal = function ConfirmModal(_ref) {
  var _message$split;

  var isOpen = _ref.isOpen,
      title = _ref.title,
      message = _ref.message,
      onClose = _ref.onClose,
      onApply = _ref.onApply,
      renderMessage = _ref.renderMessage,
      _ref$hideCloseButton = _ref.hideCloseButton,
      hideCloseButton = _ref$hideCloseButton === void 0 ? false : _ref$hideCloseButton,
      _ref$hideConfirmButto = _ref.hideConfirmButton,
      hideConfirmButton = _ref$hideConfirmButto === void 0 ? false : _ref$hideConfirmButto,
      _ref$confirmButtonTex = _ref.confirmButtonText,
      confirmButtonText = _ref$confirmButtonTex === void 0 ? '' : _ref$confirmButtonTex,
      _ref$cancelButtonText = _ref.cancelButtonText,
      cancelButtonText = _ref$cancelButtonText === void 0 ? '' : _ref$cancelButtonText,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'lg' : _ref$size,
      _ref$ariaLabel = _ref.ariaLabel,
      ariaLabel = _ref$ariaLabel === void 0 ? 'Error Message Modal' : _ref$ariaLabel,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var msg = message === null || message === void 0 ? void 0 : (_message$split = message.split) === null || _message$split === void 0 ? void 0 : _message$split.call(message, '\n');
  return /*#__PURE__*/_jsxs(Modal, _objectSpread(_objectSpread({
    isCentered: true,
    isOpen: isOpen,
    onClose: onClose,
    "aria-label": ariaLabel,
    size: size
  }, props), {}, {
    e2eid: "common_ConfirmModal_Modal",
    children: [/*#__PURE__*/_jsx(ModalOverlay, {
      e2eid: "common_ConfirmModal_ModalOverlay"
    }), /*#__PURE__*/_jsxs(ModalContent, {
      py: 6,
      px: 3,
      e2eid: "common_ConfirmModal_ModalContent",
      children: [/*#__PURE__*/_jsxs(ModalBody, {
        py: "4",
        e2eid: "common_ConfirmModal_ModalBody",
        children: [title && /*#__PURE__*/_jsxs(TitleHeader, {
          e2eid: "common_ConfirmModal_TitleHeader",
          children: [/*#__PURE__*/_jsx(WarningIcon, {
            mr: "2",
            e2eid: "common_ConfirmModal_WarningIcon"
          }), title]
        }), msg && msg.map(function (m, idx) {
          return /*#__PURE__*/_jsx(Text, {
            py: "2",
            whiteSpace: "break-spaces",
            e2eid: "common_ConfirmModal_Text",
            children: m
          }, idx);
        }), typeof renderMessage === 'function' && renderMessage()]
      }), /*#__PURE__*/_jsx(ModalFooter, {
        w: "full",
        justifyContent: "flex-end",
        e2eid: "common_ConfirmModal_ModalFooter",
        children: /*#__PURE__*/_jsxs(HStack, {
          spacing: "6",
          e2eid: "common_ConfirmModal_HStack",
          children: [onClose && !hideCloseButton && /*#__PURE__*/_jsx(Button, {
            px: "12",
            onClick: onClose,
            variant: "outline",
            e2eid: "common_ConfirmModal_Button",
            children: cancelButtonText || t('common:button.cancel', '取消')
          }), onApply && !hideConfirmButton && /*#__PURE__*/_jsx(Button, {
            px: "10",
            onClick: onApply,
            variant: "solid",
            e2eid: "common_ConfirmModal_Button_10",
            children: confirmButtonText || t('common:button.confirm', '確認')
          })]
        })
      })]
    })]
  }));
};

export default ConfirmModal;